<div>
  <ng-template appContainerRef></ng-template>
</div>

